import { ChainConfig, TokenInfo } from '../types';
import ShidoBridgeABI from './ShidoBridge.abi.json';

export const CHAIN_CONFIGS: Record<string, ChainConfig> = {
  'ethereum-sepolia': {
    name: 'Ethereum Sepolia',
    chainId: '0xaa36a7', // 11155111
    rpcUrl: 'https://ethereum-sepolia-rpc.publicnode.com',
    bip44ChainId: 2147483708,
    USDC: "0x1c7d4b196cb0c7b01d743fbc6116a902379c7238",
    USDT: "0xd9b6e07f6eb5eea0286d3fb7dfa0a50c484f61a6",
    decimals: 6,
    bridge: "0x822B5f114D239AE88017b133cBC64C36b9889783",
    icon: '/images/eth.svg',
    explorerUrl: 'https://sepolia.etherscan.io',
    nativeCurrency: {
      name: 'Sepolia Ether',
      symbol: 'ETH',
      decimals: 18
    }
  },
  'avalanche-fuji': {
    name: 'Avalanche Fuji',
    chainId: '0xa869', // 43113
    rpcUrl: 'https://avalanche-fuji-c-chain-rpc.publicnode.com',
    bip44ChainId: 2147492648,
    USDC: "0x5425890298aed601595a70ab815c96711a31bc65",
    USDT: "0x1f6515c5e45c7d572fbb5d18ce613332c17ab288",
    decimals: 6,
    bridge: "0x822B5f114D239AE88017b133cBC64C36b9889783",
    icon: '/images/avax.png',
    explorerUrl: 'https://testnet.snowtrace.io',
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18
    }
  },
  'bsc-testnet': {
    name: 'BSC Testnet',
    chainId: '0x61', // 97
    rpcUrl: 'https://bsc-testnet-rpc.publicnode.com',
    bip44ChainId: 2147484362,
    USDC: "0x64544969ed7ebf5f083679233325356ebe738930",
    USDT: "0x337610d27c682e347c9cd60bd4b3b107c9d34ddd",
    decimals: 18,
    bridge: "0x822B5f114D239AE88017b133cBC64C36b9889783",
    icon: '/images/bnb.png',
    explorerUrl: 'https://testnet.bscscan.com',
    nativeCurrency: {
      name: 'Binance Coin',
      symbol: 'BNB',
      decimals: 18
    }
  },
  'polygon-amoy': {
    name: 'Polygon Amoy',
    chainId: '0x13882', // 80002
    rpcUrl: 'https://polygon-amoy-bor-rpc.publicnode.com',
    bip44ChainId: 2147484614,
    USDC: "0x41e94eb019c0762f9bfcf9fb1e58725bfb0e7582",
    USDT: "0x4915736a3623c2bac3a4d545fd12019ad46ad6d5",
    decimals: 6,
    bridge: "0x822B5f114D239AE88017b133cBC64C36b9889783",
    icon: '/images/matic.png',
    explorerUrl: 'https://amoy.polygonscan.com',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18
    }
  },
  'arbitrum-sepolia': {
    name: 'Arbitrum Sepolia',
    chainId: '0x66eee', // 421614
    rpcUrl: 'https://arbitrum-sepolia-rpc.publicnode.com',
    bip44ChainId: 1073741826,
    USDC: "0x75faf114eafb1bdbe2f0316df893fd58ce46aa4d",
    USDT: "0xfda7a6d11fdd32f18e8d8d9ce1e97a9575141875",
    decimals: 6,
    bridge: "0x822B5f114D239AE88017b133cBC64C36b9889783",
    icon: '/images/arb.png',
    explorerUrl: 'https://sepolia.arbiscan.io',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18
    }
  },
  'base-sepolia': {
    name: 'Base Sepolia',
    chainId: '0x14a34', // 84532
    rpcUrl: 'https://base-sepolia-rpc.publicnode.com',
    bip44ChainId: 1073741841,
    USDC: "0x036cbd53842c5426634e7929541ec2318f3dcf7e",
    USDT: "",
    decimals: 6,
    bridge: "0x822B5f114D239AE88017b133cBC64C36b9889783",
    icon: '/images/base.png',
    explorerUrl: 'https://sepolia.basescan.org',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18
    }
  },
  'shido-testnet': {
    name: 'Shido Testnet',
    chainId: '0x232f', // 9007
    rpcUrl: 'https://shido-testnet-archive-lb-q1ifr9jpz.zeeve.net/USjg7xqUmCZ4wCsqEOOE/rpc',
    bip44ChainId: 1073741856,
    USDC: "0xA91054818e2af05c997379B9653B50d762e57308",
    USDT: "0xF647cC4efa502C58492792F0434931754076946F",
    decimals: 6,
    bridge: "0x822B5f114D239AE88017b133cBC64C36b9889783",
    icon: '/images/wshido.png',
    explorerUrl: 'https://testnet.shidoscan.net',
    nativeCurrency: {
      name: 'Shido',
      symbol: 'SHIDO',
      decimals: 18
    }
  }
};

export const TOKEN_INFO: Record<string, TokenInfo> = {
  'USDC': {
    symbol: 'USDC',
    name: 'USD Coin',
    icon: '/images/usdc.png',
    decimals: 6
  },
  'USDT': {
    symbol: 'USDT',
    name: 'Tether USD',
    icon: '/images/usdt.png',
    decimals: 6
  }
};

export const ERC20_ABI = [
  {
    type: 'function',
    name: 'allowance',
    stateMutability: 'view',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' }
    ],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' }
    ],
    outputs: [{ type: 'bool' }]
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'decimals',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint8' }]
  },
  {
    type: 'function',
    name: 'name',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  },
  {
    type: 'function',
    name: 'symbol',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  }
];

export const BRIDGE_ABI = ShidoBridgeABI;

export const DEFAULT_GAS_LIMIT = 1500000;
export const LOCAL_STORAGE_KEY = 'shido-bridge-transactions';
